import { render, staticRenderFns } from "./TradingPolicyDeleteDialog.vue?vue&type=template&id=9aff6072&scoped=true"
import script from "./TradingPolicyDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./TradingPolicyDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./TradingPolicyDeleteDialog.vue?vue&type=style&index=0&id=9aff6072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aff6072",
  null
  
)

export default component.exports